// Include flickity
import 'flickity/dist/flickity.pkgd.min.js';

// Set global arrowShape
const arrowShape =
  'M82.6,46H1.3v8.7h81.1L63.9,73l6.2,6.1l29.2-29l-29.2-29l-6.2,6.1L82.6,46z';

// USP Slider
$('.usp-slider').each(function (i, e) {
  if ($(e).length && $(e).find('.usp-slider__item').length > 1) {
    $(e).flickity({
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: 5000,
    });

    $(e).flickity('resize');
  }
});

// News slider
var initNewsFlickity = function ($parent) {
  $parent.find('.news-slider').each(function (i, e) {
    // prettier-ignore
    if($(e).length && (
      ($(window).width() < 768 && $(e).find('.news-slider__item').length > 1) ||
      ($(window).width() > 767 && $(window).width() < 1025 && $(e).find('.news-slider__item').length > 2) ||
      ($(window).width() > 1024 && $(e).find('.news-slider__item').length > 3)
    )) {
      $(e).flickity({
        arrowShape: arrowShape,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
      });
      $(e).flickity('resize');
    } else if($(e).hasClass('flickity-enabled')) {
      $(e).flickity('destroy');
    }
  });
};

// Image slider
var initImageFlickity = function ($parent) {
  $parent.find('.js-img-slider').each(function (i, e) {
    if ($(e).length && $(e).find('.js-img-slider__item').length > 1) {
      $(e).flickity({
        wrapAround: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
    }
  });
};

// Testimonial slider
var initTestimonialFlickity = function ($parent) {
  $parent.find('.js-testimonial-slider').each(function (i, e) {
    if ($(e).length && $(e).find('.js-testimonial-slider__item').length > 2) {
      $(e).flickity({
        cellAlign: 'left',
        groupCells: true,
        contain: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
      var resizeTimer;
      $(window).on('resize', function () {
        $('.js-testimonial-slider__item').addClass('reset-height');

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          $('.js-testimonial-slider__item').removeClass('reset-height');
        }, 250);
      });
    }
  });
};

// Logo slider
var initLogosFlickity = function ($parent) {
  $parent.find('.js-logo-slider').each(function (i, e) {
    if ($(e).length && $(e).find('.js-logo-slider__item').length > 4) {
      $(e).flickity({
        cellAlign: 'left',
        groupCells: true,
        contain: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
    }
  });
};

// Team slider
var initTeamFlickity = function ($parent) {
  $parent.find('.team-slider').each(function (i, e) {
    if ($(e).length && $(e).find('.card-team').length > 1) {
      $(e).flickity({
        watchCSS: true,
        wrapAround: true,
        arrowShape: arrowShape,
      });

      $(e).flickity('resize');
    }
  });
};

// init on the frontend
$(document).on('ready', function () {
  initNewsFlickity($('.block-news'));
  initImageFlickity($('.block-slider'));
  initTestimonialFlickity($('.block-testimonial'));
  initLogosFlickity($('.block-logos'));
  initTeamFlickity($('.block-team'));
});

// init in the gutenberg editor
// prettier-ignore
if (window.acf) {
  window.acf.addAction('render_block_preview/type=news', initNewsFlickity);
  window.acf.addAction('render_block_preview/type=slider', initImageFlickity);
  window.acf.addAction('render_block_preview/type=testimonial', initTestimonialFlickity);
  window.acf.addAction('render_block_preview/type=logos', initLogosFlickity);
  window.acf.addAction('render_block_preview/type=team', initTeamFlickity);
}



// WEBPACK FOOTER //
// ./scripts/global/flickity.js